<div class="row">
  <div class="details-secondary-text flex-12 text-start fs-xs">
    {{ value }}{{ value ? unit : '' }}
  </div>
</div>
<div class="row">
  <div class="text-start fs-2xs">{{ description }}</div>
</div>
